import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center transition-all duration-300 font-semibold tracking-widest uppercase focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none rounded-full group';
  const variants = {
    primary: 'bg-stone-900 text-white hover:bg-stone-700 hover:scale-[1.03] active:scale-[0.97] shadow-lg hover:shadow-xl',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    outline: 'border-2 border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-white'
  };
  const sizes = {
    sm: 'h-9 px-6 text-xs',
    md: 'h-12 px-8 text-xs',
    lg: 'h-14 px-12 text-sm'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-158">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" data-id="element-159" />}
    </button>;
}